import { capitalize } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSwiper } from 'swiper/react'
import AppButton from '../../../../AppButton'

const PositionSliderBtn = ({title, customSx}) => {
	const swiper = useSwiper()

	const setNewTab = () => {
		if (title === '>') {
			swiper.slideNext()
		} else {
			swiper.slidePrev()
		}
	}

	return <Box sx={{ background: (theme) => theme.palette.second, p: '8px', position: 'absolute',
		top: '-4px', zIndex: 1, ...customSx}}>
		<AppButton
			inputSx={{height: '25px', maxWidth: '35px',
				minWidth: '35px'
			}}
			onClick={setNewTab}
			title={capitalize(title)} />
	</Box>
}

PositionSliderBtn.propTypes = {
	customSx: PropTypes.object,
	title: PropTypes.string
}

export default PositionSliderBtn


